var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('symbol',{attrs:{"id":("" + _vm.prefix + _vm.slug),"viewBox":"0 0 14 14"}},[_c('path',{style:({
			transform: ("rotate3d(0, 0, 1, " + _vm.angle + "deg)"),
			transformOrigin: 'center',
		}),attrs:{"fill":_vm.disabled ? _vm.colors.disabled : _vm.colors.main,"d":"M9,2.4L7.6,3.8L9.8,6H0.3v2h9.5l-2.2,2.2L9,11.6L13.7,7L9,2.4z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }